(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("LearningItemEditSBCourseModalCtrl", ["$scope", "messageService", "learningItemSBCourseResource", "learningItemSBCourse", learningItemEditSBCourseModalCtrl]);
    function learningItemEditSBCourseModalCtrl($scope, messageService, learningItemSBCourseResource, learningItemSBCourse) {
        var vm = this;
        vm.learningItemSBCourse = learningItemSBCourse;
        vm.showErrors = false;
        vm.options = [
            { name: "common.time.30days", value: 30 },
            { name: "common.time.45days", value: 45 },
            { name: "common.time.60days", value: 60 },
            { name: "common.time.90days", value: 90 },
            { name: "common.time.6months", value: 180 },
            { name: "common.time.1year", value: 365 },
            { name: "common.time.noLimit", value: 0 }
        ];
        vm.update = function () {
            if (vm.form.$valid) {
                learningItemSBCourseResource.update(vm.learningItemSBCourse, function () {
                    //vm.learningItemUrlLocalization = result;
                    messageService.success("common.changesSaved");
                    $scope.$close(vm.learningItemSBCourse);
                }, function (error) {
                    messageService.error(error);
                });
            }
            else {
                vm.showErrors = true;
            }
        };
    }
})();
